import clientAxios from '../clients/clientAxios';
import { COUPON_PROMOS, DEFAULT_PAGE_SIZE } from '../config/apiRoutes';

export const getCouponPromos = async (page = 1, pageSize = DEFAULT_PAGE_SIZE) => {
  const { data } = await clientAxios.get(COUPON_PROMOS, {
    params: { page, limit: pageSize },
  });
  return data;
};

export const createCoupon = async (formData) => {
  const { data } = await clientAxios.post(COUPON_PROMOS, formData);
  return data;
};

export const deleteCoupon = async (couponCode) => {
  await clientAxios.delete(`${COUPON_PROMOS}/${couponCode}`);
};
